import { Component, OnInit, Inject } from '@angular/core';
import { DataDialog, Items } from '../../../core';
import { SCHEMAS } from '../data-table/data-table.config';
import { XlsxService } from '../../services/xlsx.service';
import { SnackbarService } from '../snackbar/snackbar.service';
import moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-data-import',
  templateUrl: './data-import.component.html',
  styleUrls: ['./data-import.component.sass']
})
export class DataImportComponent implements OnInit {
  dispatchDate: Date;
  day = new Date();
  fileValue;
  constructor(
    public snackBarService: SnackbarService,
    public xlsxService: XlsxService,
    public dialogRef: MatDialogRef<DataImportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataDialog
  ) {
    data = JSON.parse(JSON.stringify(data));
    this.dispatchDate = this.day;
  }
  ngOnInit() { }

  onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) {
      // throw new Error('Cannot use multiple files')
    } else {
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        const data = <any[]>this.xlsxService.importFromFile(e.target.result);
        const header: string[] = SCHEMAS[this.data.type].columns.map(i => i.name);
        const title: string[] = SCHEMAS[this.data.type].columns
          .map(i => i.title)
          .filter(i => this.data.filterColumn ? (i === 'Despacho' || i === 'SKU') : true);

        const headerXLSX = data[0];
        const valid = JSON.stringify(title) === JSON.stringify(headerXLSX);
        if (valid) {
          const parseData = data.slice(1).map(arr => {
            const obj = {};
            for (let i = 0; i < header.length; i++) {
              const k = header[i];
              obj[k] = arr[i];
            }
            return <Items>obj;
          })
          this[this.data.method](parseData);
        } else {
          this.data.data = [];
          this.data.dataParse = [];
          this.snackBarService.show('Asegúrate que el archivo tenga el formato correcto', 'error');
          setTimeout(() => {
            evt.target.value = '';
          }, 500);
        }
      };
      reader.readAsBinaryString(target.files[0]);
    }
  }

  groupSku() {
    this.data.dataCurrent = this.data.dataCurrent.map(dispatch => {
      dispatch.itemList = dispatch.itemList.reduce(this.removeduplicate, []);
      return dispatch;
    });
  }

  removeduplicate(acc, curr) {
    const existSku = acc.find(i => i.skuCode.toString() === curr.skuCode.toString());
    // se retea los valores que han sido modificados en el componente padre
    curr.pendingAmount = curr.currentAmount - curr.deliveredQuantity;
    // curr.processedAmount = curr.processedAmount - curr.pendingAmount;
    if (existSku) {
      const indexOfList = acc.findIndex(i => i.skuCode.toString() === curr.skuCode.toString());
      const list = existSku;
      const currentAmount = existSku.currentAmount + curr.currentAmount;
      const deliveredQuantity = existSku.deliveredQuantity + curr.deliveredQuantity;
      const pendingAmount = existSku.pendingAmount + curr.pendingAmount;
      const processedAmount = existSku.processedAmount + curr.processedAmount;

      list.currentAmount = currentAmount;
      list.deliveredQuantity = deliveredQuantity;
      list.pendingAmount = pendingAmount;
      list.processedAmount = processedAmount;

      acc[indexOfList] = list;
    } else {
      acc.push(curr);
    }
    return acc;
  }

  processData(load: Items[]) {
    this.data.dataParse = load.
      reduce(this.groupDispatch, [])
      .map(dispatch => {
        const realCurrent = this.data.dataCurrent.find(i => dispatch.dispatchId === i.dispatchId);
        if (!realCurrent) {
          return
        }
        realCurrent.itemList = this.filterDataItems(realCurrent.itemList, dispatch);
        return realCurrent && realCurrent.itemList.length ? realCurrent : undefined;
      })
      .filter(dispatch => dispatch);

    this.parseData(JSON.parse(JSON.stringify(this.data.dataParse)));
    this.messageSnackbar('al viaje');
  }
  /**
   * Agrupa los datos del excel por despachos y sku
   * @param acc 
   * @param cur 
   */
  groupDispatch(acc, cur) {
    const exist = acc.find(i => i.dispatchId === cur.dispatchId)
    if (exist) {
      // al insertar verificar si ya existe el sku y sumar las cantidad
      const existSku = exist.itemList.find(i => i.skuCode && cur.skuCode && i.skuCode.toString() === cur.skuCode.toString());
      if (!existSku) {
        exist.itemList.push(cur)
      } else {
        const quantity = existSku.processedAmount + cur.processedAmount;
        exist.itemList.map(i => {
          if (i.skuCode && cur.skuCode && i.skuCode.toString() === cur.skuCode.toString()) {
            i.processedAmount = quantity
          }
          return i;
        });
      }
    } else {
      acc.push({
        dispatchId: cur.dispatchId,
        itemList: [{
          dispatchId: cur.dispatchId,
          skuCode: cur.skuCode,
          skuName: cur.skuName,
          processedAmount: cur.processedAmount
        }]
      })
    }
    return acc
  }
  /**
   * Filtra y valida los despachos por sku
   * @param itemList lista del data actual
   * @param dispatch agrupación por desoachos
   */
  filterDataItems(itemList, dispatch) {
    return itemList.map(itemReal => {
      const exist = dispatch.itemList.
        find(itemTemp => itemTemp.skuCode && itemReal.skuCode && itemTemp.skuCode.toString() === itemReal.skuCode.toString() && itemReal.currentAmount - itemReal.deliveredQuantity >= 1);

        const index = dispatch.itemList.
        findIndex(itemTemp => itemTemp.skuCode && itemReal.skuCode && itemTemp.skuCode.toString() === itemReal.skuCode.toString() && itemReal.currentAmount - itemReal.deliveredQuantity >= 1);
      if (exist && exist.processedAmount <= itemReal.currentAmount - itemReal.deliveredQuantity) {
        itemReal.pendingAmount = (itemReal.currentAmount - itemReal.deliveredQuantity) - exist.processedAmount;
        itemReal.processedAmount = exist.processedAmount;
      }
      if (exist && exist.processedAmount) {
        dispatch.itemList[index].processedAmount = dispatch.itemList[index].processedAmount - itemReal.processedAmount;
        return itemReal;
      }
      return undefined;
    }).filter(dis => dis);
  }

  /** Una vez filtrado y agrupado se parsea la data para que sea visible en la tabla */
  parseData(dataParse) {
    // agrupar los skus
    this.data.data = dataParse.reduce((b, current) => {
      const listItems = current.itemList;
      listItems.map(i => {
        i.saleNoteId = current.saleNoteId
        i.dispatchId = current.dispatchId;
        return i
      });
      return b.concat(listItems);
    }, []);
  }

  processDataConfirmation(upload: any[]) {
    this.data.dataParse = upload.reduce((acc, curr) => {
      const exist = this.data.dataCurrent
        .find(i => curr.dispatchId === i.dispatchId && curr.skuCode.toString() === i.dispatchItems.skuCode.toString());
      if (exist) {
        const inAcc = acc.find(i => curr.dispatchId === i.dispatchId && curr.skuCode.toString() === i.dispatchItems.skuCode.toString());
        if (!inAcc) {
          exist.dispatchItems.dispatchDate = this.data.date
            ? moment(this.dispatchDate).format('YYYY-MM-DD hh:mm:ss')
            : exist.dispatchItems.dispatchDate;
          acc.push(exist);
        }
      }
      return acc
    }, []).filter(i => 
      i.dispatchItems.pendingAmount
      && (!i.dispatchItems.isCancelled 
      && i.dispatchItems.canceledAmount !== i.dispatchItems.pendingAmount));

    this.data.data = this.data.dataParse;
    this.messageSnackbar('al proveedor');
  }

  processDataAll(upload: any[]) {
    this.data.dataParse = upload.map(i => {
      if (i.skuCode) {
        const enumSku = i.skuCode.split('-');
        const enumDispatch = i.dispatchId.split('-');
        return {
          saleNoteId: enumDispatch[0],
          dispatchId: i.dispatchId,
          skuCode: enumSku[0],
          skuPartialSequence: Number(enumSku[1]),
          stateId: 7,
          state: 'Viaje Despachado a Cliente',
          pendingAmount: 0,
          processedAmount: i.processedAmount
        }
      } else {
        return [];
      }

    }).filter(i => i);

    this.data.data = this.data.dataParse;
  }

  messageSnackbar(text) {
    this.snackBarService
      .show(
        this.data.data.length ? 'Carga satisfactoria' : 'Ningún despacho corresponde ' + text,
        this.data.data.length ? 'success' : 'warning'
      );

    if (!this.data.data.length) {
      this.fileValue = null;
    }
  }

  /**
   * TODO no data.data
   */
  onSubmitAction() {
    if (this.data.method !== 'processData') {
      this.dialogRef.close(this.data.dataParse);
    } else {
      this.dialogRef.close(this.data.data);
    }
    
  }

  onClose() {
    this.dialogRef.close()
  }

  changeFormat() {
    this.data.dataParse = this.data.dataParse.map(i => {
      i.dispatchItems.dispatchDate = moment(this.dispatchDate).format('YYYY-MM-DD hh:mm:ss');
      return i;
    });
  }

}
